import"./App.css";
import{BrowserRouter,Navigate,Route,Routes}from"react-router-dom";
import{AlertProvider}from"./context/AlertContext";
import{AuthProvider,useAuth}from"./context/AuthContext";
import Login from"./login/Login";
import AdminPanel from"./login/Enterprise/AdminPanel";
import UpdatePassword from"./login/UpdatePassword";

function ProtectedRoute({children}){
  const{isAuthenticated,loading}=useAuth();
  if(loading)return null;
  if(!isAuthenticated)return <Navigate to="/" replace/>;
  return children;
}

function AdminPanelRoute(){
  const{user}=useAuth();
  if(user?.must_change_password)return <Navigate to="/update-password" replace/>;
  return <AdminPanel/>;
}

function UpdatePasswordRoute(){
  const{user}=useAuth();
  if(!user?.must_change_password)return <Navigate to="/admin-panel" replace/>;
  return <UpdatePassword/>;
}

function AppRoutes(){
  return(
    <Routes>
      <Route path="/" element={<Login/>}/>
      <Route path="/update-password" element={<ProtectedRoute><UpdatePasswordRoute/></ProtectedRoute>}/>
      <Route path="/admin-panel/*" element={<ProtectedRoute><AdminPanelRoute/></ProtectedRoute>}/>
    </Routes>
  );
}

export default function App(){
  return(
    <AuthProvider>
      <AlertProvider>
        <BrowserRouter>
          <AppRoutes/>
        </BrowserRouter>
      </AlertProvider>
    </AuthProvider>
  );
}